import { isWeb, SelectionGroup, YStack } from "@medbillai/ui";
import { OnboardingScreen } from "../../components/OnboardingScreen";
import { type OnDone, tagged } from "../../lib/flow-engine";
import { sentryService } from "../../lib/sentry";
import { type Intent, isIntent } from "./types";
export type IntentOutcomes = {
  selected: {
    intent: Intent;
  };
  back: {};
};
const Outcome = tagged<IntentOutcomes>();
const INTENT_OPTIONS: ReadonlyArray<{
  intent: Intent;
  label: string;
  src: {
    web: string;
    native: string;
  };
}> = [{
  intent: "bill",
  label: "Analyze my medical bill",
  src: {
    web: "/static/onboarding/intent-bill.png",
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-require-imports
    native: require("../../assets/onboarding/intent-bill.png")
  }
}, {
  intent: "learn",
  label: "Understand my benefits",
  src: {
    web: "/static/onboarding/intent-learn.png",
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-require-imports
    native: require("../../assets/onboarding/intent-learn.png")
  }
}, {
  intent: "other",
  label: "Something else",
  src: {
    web: "/static/onboarding/intent-other.png",
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-require-imports
    native: require("../../assets/onboarding/intent-other.png")
  }
}];
export function IntentScreen({
  onDone
}: {
  onDone: OnDone<IntentOutcomes>;
}) {
  return <OnboardingScreen data-sentry-element="OnboardingScreen" data-sentry-component="IntentScreen" data-sentry-source-file="Intent.tsx">
      <OnboardingScreen.Nav onBackPress={() => onDone(Outcome.back())} showLogo={false} data-sentry-element="OnboardingScreen.Nav" data-sentry-source-file="Intent.tsx" />
      <OnboardingScreen.Content data-sentry-element="OnboardingScreen.Content" data-sentry-source-file="Intent.tsx">
        <OnboardingScreen.Header alignment="left" title="How can we help?" subtitle="Let us know what's on your mind — we'll guide you step by step from there." showLogo={false} data-sentry-element="OnboardingScreen.Header" data-sentry-source-file="Intent.tsx" />
        <YStack gap="$sp1.5" data-sentry-element="YStack" data-sentry-source-file="Intent.tsx">
          <SelectionGroup mode="radio" value="" onChange={value => {
          // Values come from the typed `INTENT_OPTIONS` array, so a non-Intent
          // value should never reach here.
          // TODO Fix SelectionGroup to allow generic-typed data: https://linear.app/medbillai/issue/GRO-686/add-generic-data-support-to-selectiongroup-component
          if (!isIntent(value)) {
            sentryService.captureException(new Error(`Intent received unexpected SelectionGroup value: ${String(value)}`));
            onDone(Outcome.selected({
              intent: "other"
            }));
            return;
          }
          onDone(Outcome.selected({
            intent: value
          }));
        }} data-sentry-element="SelectionGroup" data-sentry-source-file="Intent.tsx">
            {INTENT_OPTIONS.map(({
            intent,
            label,
            src
          }) => <SelectionGroup.Row key={intent} testID={`intent-fork.${intent}`} value={intent} label={label} leading={{
            type: "image",
            source: isWeb ? src.web : src.native
          }} />)}
          </SelectionGroup>
        </YStack>
      </OnboardingScreen.Content>
    </OnboardingScreen>;
}